import React from "react";
import "./CommonDashboard.css";
import GridGenerator from "../Common/GridGenerator/GridGenerator";
import Header from "../../Layout/Header/Header";
import mineBanner from "../../Assets/Images/mine_banner.svg";
import { useSelector } from "react-redux";

const CommonDashboard = () => {
  const { mineDetails } = useSelector((state) => state.data);

  return (
    <div className="main__container">
      <Header />
      <div className="cd__content">
        <div className="cd__banner">
          <img src={mineBanner} className="mine__banner" />
          <div className="banner__overlay">
            <div className="banner__text">
              {mineDetails?.length > 0 && mineDetails[0].mines_name}
            </div>
          </div>
        </div>
        <div className="cd__cards">
          <GridGenerator />
        </div>
      </div>
    </div>
  );
};

export default CommonDashboard;
